// src/styles/theme.ts
export const theme = {
    colors: {
      primary: '#A78BFA', // Soft purple for headers, buttons, accents
      primaryDark: '#8B5CF6', // Darker purple variant for hover states
      primaryLight: '#C4B5FD', // Lighter purple variant
      background: '#FFFFFF', // Crisp white background
      backgroundAlt: '#F9FAFB', // Light gray for alternating sections
      text: '#1F2937', // Dark gray for body text
      textLight: '#6B7280', // Light gray for secondary text
    },
    fonts: {
      body: 'Inter, sans-serif',
      heading: 'Montserrat, sans-serif',
    },
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: '0.3s ease-in-out',
  };